import { EuiFlexGroup, EuiFlexItem, EuiSelect } from "@elastic/eui";
import moment from "moment";
import React, { useEffect } from "react";

export interface IStartDatePicker {
  selectedDate?: string;
  onSelectedDateChange: (date: string) => void;
  ariaLabel?: string;
}

export const PlanStartDatePicker: React.FC<IStartDatePicker> = ({
  selectedDate,
  onSelectedDateChange,
  ariaLabel,
}) => {
  const generateStartDates = () => {
    const startDays = [7, 14, 21, 28];
    const getTwoWeeksFromToday = () => {
        return moment().add(14, "days");
    }
    const twoWeeksFromToday = getTwoWeeksFromToday()

    const startDatesGreaterThanTwoWeeks = startDays.filter(
      (day) => {
        const date = getTwoWeeksFromToday().set({ date: day });
        return date >= twoWeeksFromToday
      },
    );

    let nextStartDates = startDatesGreaterThanTwoWeeks.map((day) => {
      return getTwoWeeksFromToday().set({ date: day });
    });

    const remainingDays = startDays.filter((day) => {
      const date = getTwoWeeksFromToday().set({ date: day });
      return date < twoWeeksFromToday
    });

    nextStartDates = nextStartDates.concat(
      remainingDays.map((day) => {
        return getTwoWeeksFromToday().set({ date: day }).add(1, "months");
      }),
    );

    let dateOptions = nextStartDates.map((date) => {
      return {
        value: date.format("MMMM DD, YYYY"),
        text: date.format("MMMM DD, YYYY"),
      };
    })

    //add another 4 weeks to the end of the list
    const lastDate = dateOptions[dateOptions.length - 1];
    const lastDateMoment = moment(lastDate.value, "MMMM DD, YYYY");
    dateOptions = dateOptions.concat(
      Array.from({ length: 4 }, (_) => {
        return {
          value: lastDateMoment.add(1, "weeks").format("MMMM DD, YYYY"),
          text: lastDateMoment.format("MMMM DD, YYYY"),
        };
      }),
    );

    return dateOptions;
  };

  const startDates = generateStartDates();

  const onDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const date = moment(e.target.value).format("MMMM DD, YYYY");
    onSelectedDateChange(date);
  };

  const defaultDate: string = startDates[0] ? startDates[0].value : "";

  useEffect(() => {
    if (selectedDate) {
      return;
    }

    onSelectedDateChange(defaultDate);
  }, [defaultDate, selectedDate, onSelectedDateChange]);

  return (
    <EuiFlexGroup gutterSize="s" alignItems="center">
      <EuiFlexItem grow={false}>
        <EuiSelect
          options={startDates}
          value={selectedDate ?? defaultDate}
          onChange={onDateChange}
          aria-label={ariaLabel}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
